import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { FCI_ERROR } from "@searchui-searchforms/shared/fci";
import { fciFetch } from "@/shared/lib/fci";

export interface PageContext {
    partnerId: number;
    locale: string;
    isAuthenticated: boolean;
    isInstitutional: boolean;
    runtimeConfig: {
        useDirectSearchPreferences: boolean;
    };
}

export const pageContextQueryKey = ["page-context"] as const;

const getPageContext = (): Promise<PageContext> =>
    fciFetch<PageContext>(`/api/searchforms/page-context`, {
        fci: {
            // Fetches essential page context (locale, auth, UI assets)
            // Without it, the entire page has no content to render
            errorType: FCI_ERROR.Main,
            errorInfo: "getPageContext",
        },
    });

export const pageContextQueryOptions = queryOptions({
    queryKey: pageContextQueryKey,
    queryFn: getPageContext,
});

export const usePageContextQuery = () => useSuspenseQuery(pageContextQueryOptions);
